export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  keepAlive: false,
  dynamicParam: '/:id?/:invoiceRedBlueType?',
  title: '发票详情',
} as TCommon.RouteConfig
